import actions from "./actions";
import state from "./state";
import mutations from "./mutations";

const getters = {
  getStaffIndividualEmployeeYearlyAttendanceList: (state) => state.items,
  getStaffIndividualEmployeeYearlyAttendanceListDate: (state) => state.filter.date,
};

export default {
  actions,
  state,
  mutations,
  getters,
};
